import cx from 'classnames';
import React, { useCallback } from 'react';
import { Dropdown } from 'react-bootstrap';
import shallow from 'zustand/shallow';
import { useEventsStore } from '../../store';

export const Sort = ({ className }: { className?: string }): React.ReactElement => {
  const { sortBy, sortOrder, setSort_ } = useEventsStore((v) => ({
    sortBy: v.filters.sortBy,
    sortOrder: v.filters.sortOrder,
    setSort_: v.setSort
  }), shallow);

  const setSort = useCallback(
    (value: typeof sortBy) => (): void => {
      setSort_(value, value === sortBy ? (sortOrder === 'ASC' ? 'DESC' : 'ASC') : 'ASC');
    },
    [setSort_, sortBy, sortOrder]
  );

  const SortValue = useCallback(
    ({
      value,
      children
    }: {
      // eslint-disable-next-line react/no-unused-prop-types
      value: typeof sortBy;
      // eslint-disable-next-line react/no-unused-prop-types
      children: React.ReactNode;
    }): React.ReactElement | null => (
      <Dropdown.Item className='d-flex' active={sortBy === value} onSelect={setSort(value)}>
        <span className='flex-grow-1'>{children}</span>
        {value === sortBy ? (
          <span key={sortOrder} className='ml-8px' style={{ marginRight: -8 }}>
            {sortOrder === 'DESC' ? (
              <i className='fad fa-sort-amount-down' />
            ) : (
              <i className='fad fa-sort-amount-up' />
            )}
          </span>
        ) : null}
      </Dropdown.Item>
    ),
    [setSort, sortBy, sortOrder]
  );

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant={cx({
          'secondary': !(sortOrder === 'ASC' && sortBy === 'startTime'),
          'outline-lightgrey': sortOrder === 'ASC' && sortBy === 'startTime'
        })}
        className={className}
      >
        Sort
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <SortValue value='startTime'>Time</SortValue>
        <SortValue value='eid'>EID</SortValue>
        <SortValue value='cid'>CID</SortValue>
        <SortValue value='organizationName'>Organization Name</SortValue>
      </Dropdown.Menu>
    </Dropdown>
  );
};
